class NewFacilityModalController {

    constructor(
        NewFacilityModalService
    ) {
        'ngInject'

        this.NewFacilityModalService = NewFacilityModalService;
        this.selectedCampus = undefined;
        this.newFacilityName = undefined;
        this.campusList = this.resolve.campusList;
    }

    /***
     * Close the modal.
     */
    closeModal() {
        this.modalInstance.close();
    }

    setCampus(item) {
        this.selectedCampus = item;
    }

    /***
     * Triggered when the "Save" button on the modal is clicked. Creates a new facility, assigns it to the selected
     * campus, and updates the tree navigation on the main Client Edit page.
     */
    saveModal() {
        this.NewFacilityModalService.createFacility(this.selectedCampus.id,
                                                    this.newFacilityName)
            .then((successResponse) => {
                this.resolve.parentController.updateTree();
                this.modalInstance.close();
            }, (errorResponse) => {

            })
    }

}

export default NewFacilityModalController;


// WEBPACK FOOTER //
// ./app/components/client-edit/new-facility-modal/new-facility-modal-controller.js